<script>
import CartModel from '@/models/CartModel'
import CustomerModel from '@/models/CustomerModel'
import SectionModel from '@/models/SectionModel'
import AvailabilityModel from '@/models/AvailabilityModel'
import _get from 'lodash/get'

import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'WithCart',
  props: {
    isCustom: {
      type: Boolean,
      default: false,
    },
    isMerchant: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: true,
      cartId: null,
    }
  },
  async created() {
    try {
      if (!this.isCustom) {
        await this.fetchMenu()
        await this.fetchUpcomingAvailabilities()
        if (!this.isMerchant) {
          let userResponse = await CustomerModel.fetchShopCustomerData(
            this.getAuthUserId
          )
          let user = _get(userResponse, 'response.data.data')
          if (user) {
            await this.setUser(user)
          }
        }
      }
      let cart = await this.initCart(this.isCustom)
      this.cartId = cart.id
      // this.fetchShopInterval = setInterval(() => this.fetchShop(true), 10000)
    } catch (error) {
      // console.error(JSON.stringify(error))
    } finally {
      this.loading = false
    }
  },

  computed: {
    ...mapGetters('auth', ['getAuthUserId']),

    sections() {
      return SectionModel.query()
        .with('items')
        .orderBy('order')
        .all()
    }, // sections
    availabilities() {
      return AvailabilityModel.query()
        .with('items')
        .orderBy('order')
        .all()
    }, // availabilities
    cart() {
      return CartModel.query()
        .where('id', this.cartId)
        .withAllRecursive()
        .first()
    }, // cart
  },
  methods: {
    ...mapActions('shop', ['fetchMenu']),
    ...mapActions('auth', ['setUser']),
    ...mapActions('cart', ['initCart', 'fetchAvailability']),
    ...mapActions('availabilities', ['fetchUpcomingAvailabilities']),
  },
  render() {
    return this.$scopedSlots.default({
      sections: this.sections,
      availabilities: this.availabilities,
      cart: this.cart,
      loading: this.loading,
    })
  },
}
</script>
